export class LazyValue {
    get value() {
        if (this._value === undefined && this.setter) {
            this._value = this.setter();
        }
        if (this._value === undefined) {
            const error = this.error();
            if (error instanceof Error)
                throw error;
            throw new Error(error);
        }
        return this._value;
    }
    get isInit() {
        if (this._value === undefined && this.setter) {
            this._value = this.setter();
        }
        return this._value !== undefined;
    }
    constructor(error, setter) {
        this.error = error;
        this.setter = setter;
    }
    set(value) {
        this._value = value;
    }
}
export const lazyValue = (error, setter) => new LazyValue(error, setter);
//# sourceMappingURL=lazy-value.js.map